import './modules/arrange';
import { setNavColorScheme } from './modules/color-scheme';
import { CLASSNAMES, ELEMENTS } from './modules/lib';

const onWindowClick = (e) => {
	const openSubMenuListItem = ELEMENTS.openSubMenuListItem();
	if (!openSubMenuListItem) return;

	const eventPath = typeof e.composedPath === 'function' ? e.composedPath() : [];
	const clickedInsideOpenSubMenu = eventPath.includes(openSubMenuListItem) || openSubMenuListItem.contains(e.target);
	const clickedColorModeSwitch = eventPath.some((node) => node instanceof Element && node.closest('.lvl--color-mode'));

	if (!clickedInsideOpenSubMenu && !clickedColorModeSwitch) {
		closeOpenSubMenus();
		window.removeEventListener('click', onWindowClick);
	}
};

const closeOpenSubMenus = () => {
	closeLevel(ELEMENTS.openSubMenuListItem());
};

const levelIsOpen = (listItem) => listItem.classList.contains(CLASSNAMES.levelOpen);

const setExpandedState = (listItem, isOpen) => {
	// Toggle aria-expanded on the trigger button and hidden on the related sub navigation.
	const trigger = listItem.querySelector(':scope > button');
	if (trigger) {
		trigger.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
	}

	const subNav = listItem.querySelector(':scope > nav.sub');
	if (subNav) {
		if (isOpen) {
			subNav.removeAttribute('hidden');
		} else {
			subNav.setAttribute('hidden', '');
		}
	}
};

const openSubMenu = (listItem) => {
	// Prevent multiple first level nav items from being open at the same time
	closeOpenSubMenus();
	listItem.classList.add(CLASSNAMES.levelOpen);
	setExpandedState(listItem, true);

	// Focus search input when opening submenu
	if (listItem === ELEMENTS.searchListItem()) {
		ELEMENTS.searchListItem().querySelector('input')?.focus();
	}

	ELEMENTS.nav()?.dispatchEvent(new CustomEvent('subMenuChange'));

	// Register event listener on the window level to close submenu when clicking outside
	window.addEventListener('click', onWindowClick);
};

const openLevel = (listItem) => {
	// Prevent multiple first level nav items from being open at the same time
	ELEMENTS.openLevelListItem()?.classList.remove(CLASSNAMES.levelOpen);
	listItem.classList.add(CLASSNAMES.levelOpen);
};

const closeLevel = (listItem) => {
	if (!listItem) return;
	listItem.classList.remove(CLASSNAMES.levelOpen);
	setExpandedState(listItem, false);
	ELEMENTS.nav()?.dispatchEvent(new CustomEvent('subMenuChange'));
};

// Open stage when button is clicked
ELEMENTS.subMenuTriggerButtons().forEach((button) => {
	button.addEventListener('click', () => {
		const listItem = button.closest('li');

		// Open or close the level
		if (levelIsOpen(listItem)) {
			closeLevel(listItem);
		} else {
			openSubMenu(listItem);
		}
	});
});

ELEMENTS.levelTriggerButtons().forEach((button) => {
	button.addEventListener('click', () => {
		const listItem = button.closest('li');

		// Open or close the level
		if (levelIsOpen(listItem)) {
			closeLevel(listItem);
		} else {
			openLevel(listItem);
		}
	});
});

if (ELEMENTS.nav()) {
	// Handle the color scheme
	['scroll', 'DOMContentLoaded', 'resize'].forEach((type) => {
		window.addEventListener(type, setNavColorScheme);
	});

	ELEMENTS.nav().addEventListener('subMenuChange', setNavColorScheme);
}
